<template>
  <site-modal ID="resumeModal" modalSize="large" @Closed="closedResumeModal">
    <template #header>
      <h4 class="text-start w-100 text-start pt-2">Résumé</h4>
    </template>
    <template #body>
      <div class="ltr">
        <ul style="direction: ltr" class="list-group ul-resume">
          <li class="list-group-item bg-gray-900 text-white">
            HIGHLIGHT OF QUALIFICATIONS
          </li>
          <li class="list-group-item black">
            <p style="text-align: justify">
              As a clinical psychologist, I am currently the founder and
              technical supervisor of Organic-Minded clinic, the biggest mental
              health institute in Iran. This clinic is currently the most
              well-known clinic in Iran, employing more than 250 psychologists
              and psychiatrists. It offers various services, including
              individual psychotherapy, couple therapy, treatment of child and
              adolescent disorders, and psychotherapy for the elderly. My
              colleagues and I designed a dedicated software system for the
              clinic that can refer countless clients between different
              therapists with different specialties and in various centers
              without any errors. In this institute, I regularly supervise and
              teach my colleagues. I am also involved in multiple research to
              facilitate diagnosis and improve psychotherapy techniques. I have
              expertise in common mental disorders, which include depressive
              disorders, anxiety disorders, medically unexplained pain, and
              other conditions often mixed with interpersonal or personality
              disorders.
            </p>
          </li>
          <li class="list-group-item bg-gray-900 text-white">Education</li>
          <li class="list-group-item black">
            <strong
              >Ph.D., Clinical Psychology, University of Social Welfare and
              Rehabilitation Sciences, Tehran, Iran, 2010-2016</strong
            >
            <p>
              Dissertation title: Efficacy of Intensive Short-Term Dynamic
              Psychotherapy for Medically Unexplained Pain: A Pilot Three-Armed
              Randomized Controlled Trial Comparison with Mindfulness-Based
              Stress Reduction.
            </p>
          </li>
          <li class="list-group-item black">
            <strong
              >M.A., Psychology, University of Tehran, Iran, 2008 - 2010</strong
            >
            <p>
              Thesis title: Vigabatrin Attenuates the Development And Expression
              of Tolerance to Morphine-Induced Antinociception in Male Mice.
            </p>
          </li>
          <li class="list-group-item black">
            <strong
              >B.A., Clinical Psychology, Kharazmi University, Iran, 2003 –
              2008</strong
            >
          </li>
          <li class="list-group-item bg-gray-900 text-white">
            SELECTED RESEARCH PROJECTS
          </li>
          <li class="list-group-item black">
            <strong
              >Internet-delivered psychotherapy vs. in-person delivery of
              psychotherapy:</strong
            >
            Telemedicine offers a solution to the problems of accessibility and
            affordability. Developing methods for the widespread use of video
            conferencing psychotherapy in treating patients is critical. Long
            before the coronavirus disease (COVID-19) pandemic, I showed that
            Internet-delivered psychotherapy can be a more suitable format for
            some disorders.
          </li>
          <li class="list-group-item black">
            <strong
              >Diagnosing medically unexplained symptoms (MUS) in the emergency
              departments:</strong
            >
            MUS’s are symptoms that cannot be fully explained by medical
            diagnosis, injury, medication intake, drugs, or alcohol. Providing
            an emotion-focused assessment service to explore emotional
            contributors to MUS is a culturally new concept within the
            traditional model of emergency medicine. I developed a multi-step
            approach to educate physicians and patients on how such a service
            might benefit them and their patients. I worked on how to detect
            whether emotional factors play a role in symptom formation, how to
            engage the patient in a non-threatening discussion of emotional
            factors of their symptomatology, and how to refer patients for
            assessment, including patients who initially felt threatened or
            dismissed by the referral.
          </li>
          <li class="list-group-item black">
            <strong
              >Comparison effectiveness of different psychotherapy
              approaches:</strong
            >
            I have worked many years to find the most appropriate psychological
            treatment for different mental pathologies. I showed that cognitive
            therapy can be more effective for patients with fragile character
            structures. On the contrary, emotion-focused therapies may be
            suitable for resistant patients with high anxiety capacity.
          </li>
          <li class="list-group-item bg-gray-900 text-white">
            FIELDS OF EXPERTISE
          </li>
          <li class="list-group-item black">
            Structured Clinical Interview Based on DSM-5 (SCID-5)
          </li>
          <li class="list-group-item black">
            Intensive Short-Term Dynamic Psychotherapy (ISTDP)
          </li>
          <li class="list-group-item black">
            Accelerated Experiential Dynamic Psychotherapy (AEDP)
          </li>
          <li class="list-group-item black">
            Mindfulness Stress Reduction Based on Cognitive Therapy (MBSR)
          </li>
          <li class="list-group-item black">
            Familiar with SPSS, Lisrel, Mendeley
          </li>
          <li class="list-group-item bg-gray-900 text-white">
            AREAS OF INTEREST
          </li>
          <li class="list-group-item black">
            Biometric approach in psychodiagnosis
          </li>
          <li class="list-group-item black">
            Machine learning in psychodiagnosis
          </li>
          <li class="list-group-item black">
            Mapping patterns of change in psychotherapy
          </li>
          <li class="list-group-item black">
            Psychosomatic and psychogenic illnesses
          </li>
          <li class="list-group-item black">
            Neuropharmacology and psychiatry
          </li>
          <li class="list-group-item black">
            The role of psychotherapy in a general hospital
          </li>
          <li class="list-group-item bg-gray-900 text-white">
            TEACHING EXPERIENCE
          </li>
          <li class="list-group-item black">
            Psychopathology, University of Social Welfare and Rehabilitation,
            2012-2014.
          </li>
          <li class="list-group-item black">
            Short-Term Psychotherapy, Organic-Minded Mental Clinic,
            2016-present.
          </li>
          <li class="list-group-item bg-gray-900 text-white">
            AWARD AND HONORS
          </li>
          <li class="list-group-item black">
            Selected member of Iran’s National Elites Foundation
          </li>
          <li class="list-group-item bg-gray-900 text-white">
            PROFESSIONAL ACTIVITIES
          </li>
          <li class="list-group-item black">
            <strong>Founder, CEO, and Technical Supervisor,</strong>
            Organic-Minded Mental Health Clinic, Iran.
          </li>
          <li class="list-group-item bg-gray-900 text-white">
            PEER-REVIEWED PUBLICATIONS
          </li>
          <li class="list-group-item black">
            Google Scholar:<a
              target="_blank"
              href="https://scholar.google.com/citations?hl=en&amp;user=wf2CFrgAAAAJ"
              >https://scholar.google.com/citations?hl=en&amp;user=wf2CFrgAAAAJ</a
            >
          </li>
          <li class="list-group-item black">
            Linkedin:<a
              href="https://www.linkedin.com/in/behzad-chavooshi-4b1436173/"
              target="_blank"
              >https://www.linkedin.com/in/behzad-chavooshi-4b1436173/</a
            >
          </li>
          <li class="list-group-item black">
            <ul style="list-style-type: decimal; margin: 0">
              <li>
                <strong>Chavooshi B,</strong>Saberi M, Tavallaie A, Sahraei H.
                Psychotherapy for Medically Unexplained Pain: A randomized
                clinical trial comparing intensive short-term dynamic
                psychotherapy and cognitive behavior therapy. Psychosomatics.
                2017;58(5):506-518.<a
                  href="https://doi.org/10.1016/j.psym.2017.01.003"
                  target="_blank"
                  >https://doi.org/10.1016/j.psym.2017.01.003</a
                >
              </li>
              <li>
                <strong>Chavooshi B,</strong>Mohammadkhani P, Dolatshahee B.
                Telemedicine vs. in-person delivery of intensive short-term
                dynamic psychotherapy for patients with medically unexplained
                pain: A 12-month randomized, controlled trial. J Telemed
                Telecare. 2016; 1357633X15627382.<a
                  target="_blank"
                  href="https://doi.org/10.1177/1357633X15627382"
                  >https://doi.org/10.1177/1357633X15627382</a
                >
              </li>
              <li>
                <strong>Chavooshi B,</strong>Mohammadkhani P, Dolatshahi B. A
                Randomized Double-Blind Controlled Trial Comparing Davanloo
                Intensive Short-Term Dynamic Psychotherapy as Internet-Delivered
                Vs Treatment as Usual for Medically Unexplained Pain: A 6-Month
                Pilot Study. Psychosomatics. 2016;57(3):292-300.<a
                  target="_blank"
                  href="https://doi.org/10.1016/j.psym.2016.01.001"
                  >https://doi.org/10.1016/j.psym.2016.01.001</a
                >
              </li>
              <li>
                <strong>Chavooshi B,</strong>Mohammadkhani P, Dolatshahee B.
                Efficacy of Intensive Short-Term Dynamic Psychotherapy for
                Medically Unexplained Pain: A Pilot Three-Armed Randomized
                Controlled Trial Comparison with Mindfulness-Based Stress
                Reduction. Psychother Psychosom. 2016;85(2):123-5. DOI:
                10.1159/000441698.<a
                  target="_blank"
                  href="https://www.jstor.org/stable/48516675"
                  >https://www.jstor.org/stable/48516675</a
                >
              </li>
              <li>
                <strong>Chavooshi B,</strong>Saberi M, Pournaghash Tehrani S,
                Bakhtiarian A, Ahmadiani A, Haghparast A. Vigabatrin attenuates
                the development and expression of tolerance to morphine-induced
                antinociception in mice. Pharmacol Biochem Behav. 2009;
                93(2):155-9.<a
                  href="https://doi.org/10.1016/j.pbb.2009.05.002"
                  target="_blank"
                  >https://doi.org/10.1016/j.pbb.2009.05.002</a
                >
              </li>
              <li>
                <strong>Chavooshi B.</strong>Suppressive effects of lamotrigine
                on the development and expression of tolerance to
                morphine-induced antinociception in the male mouse. Brain Res.
                2009;29;1291:32-9.<a
                  target="_blank"
                  href="https://doi.org/10.1016/j.brainres.2009.07.014"
                  >https://doi.org/10.1016/j.brainres.2009.07.014</a
                >
              </li>
              <li>
                Saberi M,<strong>Chavooshi B,</strong>Ghorbani M, Saberi F.
                Vitex agnus-castus fruit extract restrains acquisition and
                expression of morphine-induced tolerance in mice.
                Pharmacologyonline 2016 (1), 127-133.<a
                  target="_blank"
                  href="https://pharmacologyonline.silae.it/files/archives/2016/vol1/PhOL_2016_1_A015_09_Saberi_127_133.pdf"
                  >https://pharmacologyonline.silae.it/files/archives/2016/vol1/PhOL_2016_1_A015_09_Saberi_127_133.pdf</a
                >
              </li>
              <li>
                Saberi M,<strong>Chavooshi B.</strong>Interaction of Vitex
                Agnus-Castus Fruit Extract with Morphine-Induced Tolerance in
                Mice: PP76. 2012 Pain Practice.<a
                  target="_blank"
                  href="https://sciexplore.ir/Documents/Details/052-871-199-383"
                  >https://sciexplore.ir/Documents/Details/052-871-199-383</a
                >
              </li>
              <li>
                Baghooli H, Toeiserkani M, Chavooshi B. Vineland Adaptive
                Behavior Scale for People with Mental Retardation, Emotional
                Disorders, and Behavioral Problems. Iran Rehabil J.
                2009;7(2):47-56.<a
                  target="_blank"
                  href="https://irj.uswr.ac.ir/article-1-341-en.html"
                  >https://irj.uswr.ac.ir/article-1-341-en.html</a
                >
              </li>
            </ul>
          </li>
          <li class="list-group-item bg-gray-900 text-white">
            PROFESSIONAL MEMBERSHIPS
          </li>
          <li class="list-group-item black">
            <strong>Membership and professional license</strong> from the
            Psychology and Counseling Organization (<a
              href="https://pcoiran.ir"
              target="_blank"
              >pcoiran.ir</a
            >), Iran, 2016-present
          </li>
          <li class="list-group-item black">
            <strong>Professional license</strong> from the Ministry of Welfare
            and Social Security (<a
              target="_blank"
              href="http://shafaf.behzisti.net/didban"
              >shafaf.behzisti.ir/map</a
            >), Iran, 2019-present
          </li>
          <li class="list-group-item black">
            <strong>Professional license</strong> from the Ministry of Sport and
            Youth (<a
              target="_blank"
              href="https://www.migna.ir/news/45732/%D9%81%D8%B1%D8%A7%D8%AE%D9%88%D8%A7%D9%86-%D8%AB%D8%A8%D8%AA-%D9%86%D8%A7%D9%85-%D8%B5%D8%AF%D9%88%D8%B1-%D9%85%D8%AC%D9%88%D8%B2-%D9%85%D8%B1%D8%A7%DA%A9%D8%B2-%D9%85%D8%B4%D8%A7%D9%88%D8%B1%D9%87-%D8%A7%D8%B2%D8%AF%D9%88%D8%A7%D8%AC-%D8%AA%D8%AD%DA%A9%DB%8C%D9%85-%D8%AE%D8%A7%D9%86%D9%88%D8%A7%D8%AF%D9%87-%D9%87%D9%85%D8%AF%D8%A7%D9%86"
              >moshaver.msy.gov.ir</a
            >), Iran, 2020-present
          </li>
          <li class="list-group-item bg-gray-900 text-white">
            MY OTHER ACTIVITY
          </li>
          <li class="list-group-item black">
            In addition to research and clinical practice, my most important
            concern is to increase psychological knowledge of the people of my
            country, so on my official Instagram page (<a
              target="_blank"
              href="https://www.instagram.com/dr.behzad.chavooshi/?hl=en"
              >@dr.behzad.chavooshi</a
            >), which has more than a million followers, I post various articles
            every day to take a step toward increasing people’s mental health.
          </li>
          <li class="list-group-item bg-gray-900 text-white">
            HOBBIES AND INTERESTS
          </li>
          <li class="list-group-item black">Playing the Cello</li>
          <li class="list-group-item black">Running</li>
          <li class="list-group-item black">Writing blog posts</li>
        </ul>
      </div>
    </template>
    <template #footer>
      <div></div>
    </template>
  </site-modal>

  <div class="container mt-4" id="container">
    <div
      class="row aos-init text-center-xs"
      data-aos="fade-up"
      data-aos-delay="300"
    >
      <h2 class="fw-bold" v-if="!isMobile">
        <svg
          width="26px"
          height="26px"
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          class="bi bi-info-circle"
          viewBox="0 0 16 16"
        >
          <path
            d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
          ></path>
          <path
            d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
          ></path>
        </svg>

        درباره ما
      </h2>

      <div class="col-12 col-md-12 col-sm-12 px-4">
        <div
          class="mx-3 my-4 aos-init aos-animate"
          data-aos="fade-in"
          data-aos-delay="300"
        >
          <div class="bg-light p-4 rounded-xl">
            <!-- mobile : top arrow : documentation/util-misc.html -->
            <!-- <i
              class="arrow arrow-lg arrow-top arrow-center border-light d-block d-md-none"
            ></i> -->
            <!-- desktop side arrow : documentation/util-misc.html -->
            <!-- <i
              class="arrow arrow-lg arrow-start mt-3 border-light d-none d-md-inline-block d-lg-inline-block d-xl-inline-block"
            ></i> -->

            <!-- <h1 class="fw-bold mb-1">ارگانیک مایندد</h1> -->

            <p
              class="h6 text-justified lead fs-6 m-4"
              style="line-height: 1.7rem"
            >
              مرکز روانشناسی و روانپزشکی ارگانیک مایندد، در سال ۱۳۹۱ توسط
              <a href="#" @click="showResume"> دکتر بهزاد چاوشی </a>
              پایه ریزی شد. در حال حاضر، این مجموعه، به عنوان یک مدل موفق و
              پیشرو در حوزه ارتقای بهداشت روان در تلاش است تا دسترسی سریع، ارزان
              و با کیفیت به انواع خدمات روانشناسی و روانپزشکی را برای احاد جامعه
              فراهم نماید. این مرکز با بهره‌گیری‌ از دانش فنی در حوزه
              برنامه‌نویسی و سرمایه‌گذاری در ابداع زیرساختهای انلاین توانسته به
              اولین مرکز ارائه خدمات بهداشت روان بدل شود که می‌تواند با ضریب
              خطای صفر، در سریعترین زمان ممکن، جلسات رواندرمانی حضوری و انلاین
              را بین متقاضیان و متخصصین برقرار نماید. این وب‌سایت هم به عنوان
              بخشی از دستاوردهای انفورماتیک این مرکز، به جهت دسترسی اسانتر و
              خدمات دهی با کیفیت‌تر به شما مراجعین محترم طراحی شده است. در پایان
              قابل ذکر است که تمامی متخصصین حاضر در این مجموعه از بهترینهای این
              رشته انتخاب شده اند و همگی از مراجع ذیصلاح دارای مجوز فعالیت
              حرفه‌ای هستند.
            </p>

            <p class="lead max-w-600"></p>

            <!-- <div class="mt-4">
              <a
                href="https://www.linkedin.com/in/behzad-chavooshi-4b1436173"
                class="btn btn-sm btn-linkedin transition-hover-top mb-2 rounded-circle"
                rel="noopener"
                aria-label="Behzad Chavooshi linkedin page"
                target="_blank"
                title="Linkedin"
              >
                <i class="fi fi-social-linkedin"></i>
              </a>

              <a
                href="https://www.instagram.com/dr.behzad.chavooshi"
                class="btn btn-sm btn-instagram transition-hover-top mb-2 rounded-circle"
                rel="noopener"
                aria-label="Behzad Chavooshi Instagram Page"
                target="_blank"
                title="Instagram"
              >
                <i class="fi fi-social-instagram"></i>
              </a>

              <a
                href="#"
                @click="showResume"
                class="btn btn-sm btn-dark btn-email transition-hover-top mb-2 rounded-circle"
                rel="noopener"
                aria-label="resume"
                title="Resume"
              >
                <i class="fi fi-user-male"></i>
              </a>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from 'bootstrap';
import { isMobile } from 'mobile-device-detect';

export default {
  data() {
    return {
      isMobile: isMobile,
      resumeModal: new Object(),
    };
  },
  methods: {
    showResume() {
      this.resumeModal.show();
    },

    closedResumeModal() {
      this.resumeModal.hide();
    },
  },
  async mounted() {
    this.resumeModal = new Modal(document.getElementById('resumeModal'), {
      keyboard: false,
    });
  },
};
</script>
<style>
.ul-resume {
}
.ul-resume li {
  text-align: left !important;
  /* font-family: Calibri, 'Gill Sans', 'Gill Sans MT', 'Trebuchet MS', sans-serif; */
}
.ul-resume li a {
  color: #000 !important;
  /* font-family: Calibri, 'Gill Sans', 'Gill Sans MT', 'Trebuchet MS', sans-serif; */
}
</style>

<style scoped>
@media screen and (min-width: 767px) {
  #container {
    margin-bottom: 15vh;
  }
}
</style>
